import logo from '../assets/images/Component3.svg'

const Logo = () => {
	return <img src={logo} alt='jobify' className='logo' />
}

export default Logo
